import { schema as normalizr } from 'normalizr';
export const Achievement = new normalizr.Entity(
  'achievements',
  {},
  {
    idAttribute: 'row',
  },
);
export const AchievementItem = new normalizr.Entity(
  'achievement_items',
  {},
  {
    idAttribute: 'row',
  },
);
export const AchievementSet = new normalizr.Entity(
  'achievement_sets',
  {},
  {
    idAttribute: 'row',
  },
);
export const AchievementSetReward = new normalizr.Entity(
  'achievement_set_rewards',
  {},
  {
    idAttribute: 'row',
  },
);
export const AchievementSetsDisplay = new normalizr.Entity(
  'achievement_sets_displays',
  {},
  {
    idAttribute: 'row',
  },
);
export const ActiveSkill = new normalizr.Entity(
  'active_skills',
  {},
  {
    idAttribute: 'row',
  },
);
export const ActiveSkillTargetType = new normalizr.Entity(
  'active_skill_target_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const ActiveSkillType = new normalizr.Entity(
  'active_skill_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const AreaTransitionAnimation = new normalizr.Entity(
  'area_transition_animations',
  {},
  {
    idAttribute: 'row',
  },
);
export const AreaTransitionAnimationType = new normalizr.Entity(
  'area_transition_animation_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const AreaTransitionInfo = new normalizr.Entity(
  'area_transition_infos',
  {},
  {
    idAttribute: 'row',
  },
);
export const AreaType = new normalizr.Entity(
  'area_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const ArmourClass = new normalizr.Entity(
  'armour_classes',
  {},
  {
    idAttribute: 'row',
  },
);
export const ArmourSurfaceType = new normalizr.Entity(
  'armour_surface_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const ArmourType = new normalizr.Entity(
  'armour_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const Ascendancy = new normalizr.Entity(
  'ascendancies',
  {},
  {
    idAttribute: 'row',
  },
);
export const AtlasNode = new normalizr.Entity(
  'atlas_nodes',
  {},
  {
    idAttribute: 'row',
  },
);
export const AtlasQuestItem = new normalizr.Entity(
  'atlas_quest_items',
  {},
  {
    idAttribute: 'row',
  },
);
export const Attribute = new normalizr.Entity(
  'attributes',
  {},
  {
    idAttribute: 'row',
  },
);
export const BackendError = new normalizr.Entity(
  'backend_errors',
  {},
  {
    idAttribute: 'row',
  },
);
export const BaseItemType = new normalizr.Entity(
  'base_item_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const BeyondDemon = new normalizr.Entity(
  'beyond_demons',
  {},
  {
    idAttribute: 'row',
  },
);
export const BindableVirtualKey = new normalizr.Entity(
  'bindable_virtual_keys',
  {},
  {
    idAttribute: 'row',
  },
);
export const BloodType = new normalizr.Entity(
  'blood_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const Bloodline = new normalizr.Entity(
  'bloodlines',
  {},
  {
    idAttribute: 'row',
  },
);
export const BuffCategory = new normalizr.Entity(
  'buff_categories',
  {},
  {
    idAttribute: 'row',
  },
);
export const BuffDefinition = new normalizr.Entity(
  'buff_definitions',
  {},
  {
    idAttribute: 'row',
  },
);
export const BuffGroup = new normalizr.Entity(
  'buff_groups',
  {},
  {
    idAttribute: 'row',
  },
);
export const BuffMergeMode = new normalizr.Entity(
  'buff_merge_modes',
  {},
  {
    idAttribute: 'row',
  },
);
export const BuffVisual = new normalizr.Entity(
  'buff_visuals',
  {},
  {
    idAttribute: 'row',
  },
);
export const BuffVisualOrbType = new normalizr.Entity(
  'buff_visual_orb_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const Character = new normalizr.Entity(
  'characters',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterAudioEvent = new normalizr.Entity(
  'character_audio_events',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterPanelDescriptionMode = new normalizr.Entity(
  'character_panel_description_modes',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterPanelStat = new normalizr.Entity(
  'character_panel_stats',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterPanelStatContext = new normalizr.Entity(
  'character_panel_stat_contexts',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterPanelTab = new normalizr.Entity(
  'character_panel_tabs',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterStartItem = new normalizr.Entity(
  'character_start_items',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterStartQuestState = new normalizr.Entity(
  'character_start_quest_states',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterStartState = new normalizr.Entity(
  'character_start_states',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterStartStateSet = new normalizr.Entity(
  'character_start_state_sets',
  {},
  {
    idAttribute: 'row',
  },
);
export const CharacterTextAudio = new normalizr.Entity(
  'character_text_audios',
  {},
  {
    idAttribute: 'row',
  },
);
export const Chest = new normalizr.Entity(
  'chests',
  {},
  {
    idAttribute: 'row',
  },
);
export const ChestCluster = new normalizr.Entity(
  'chest_clusters',
  {},
  {
    idAttribute: 'row',
  },
);
export const ChestEffect = new normalizr.Entity(
  'chest_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const ClientString = new normalizr.Entity(
  'client_strings',
  {},
  {
    idAttribute: 'row',
  },
);
export const CloneShotVariation = new normalizr.Entity(
  'clone_shot_variations',
  {},
  {
    idAttribute: 'row',
  },
);
export const Command = new normalizr.Entity(
  'commands',
  {},
  {
    idAttribute: 'row',
  },
);
export const ComponentArmour = new normalizr.Entity(
  'component_armours',
  {},
  {
    idAttribute: 'row',
  },
);
export const ComponentAttributeRequirement = new normalizr.Entity(
  'component_attribute_requirements',
  {},
  {
    idAttribute: 'row',
  },
);
export const ComponentCharge = new normalizr.Entity(
  'component_charges',
  {},
  {
    idAttribute: 'row',
  },
);
export const CooldownBypassType = new normalizr.Entity(
  'cooldown_bypass_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const CooldownGroup = new normalizr.Entity(
  'cooldown_groups',
  {},
  {
    idAttribute: 'row',
  },
);
export const CraftingBenchCustomAction = new normalizr.Entity(
  'crafting_bench_custom_actions',
  {},
  {
    idAttribute: 'row',
  },
);
export const CraftingBenchOption = new normalizr.Entity(
  'crafting_bench_options',
  {},
  {
    idAttribute: 'row',
  },
);
export const CurrencyItem = new normalizr.Entity(
  'currency_items',
  {},
  {
    idAttribute: 'row',
  },
);
export const CurrencyStashTabLayout = new normalizr.Entity(
  'currency_stash_tab_layouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const CurrencyUseType = new normalizr.Entity(
  'currency_use_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const DailyMission = new normalizr.Entity(
  'daily_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const DailyOverride = new normalizr.Entity(
  'daily_overrides',
  {},
  {
    idAttribute: 'row',
  },
);
export const DamageParticleEffect = new normalizr.Entity(
  'damage_particle_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const Dance = new normalizr.Entity(
  'dances',
  {},
  {
    idAttribute: 'row',
  },
);
export const DaressoPitFight = new normalizr.Entity(
  'daresso_pit_fights',
  {},
  {
    idAttribute: 'row',
  },
);
export const Default = new normalizr.Entity(
  'defaults',
  {},
  {
    idAttribute: 'row',
  },
);
export const DefaultMonsterStat = new normalizr.Entity(
  'default_monster_stats',
  {},
  {
    idAttribute: 'row',
  },
);
export const DescentExile = new normalizr.Entity(
  'descent_exiles',
  {},
  {
    idAttribute: 'row',
  },
);
export const DescentRewardChest = new normalizr.Entity(
  'descent_reward_chests',
  {},
  {
    idAttribute: 'row',
  },
);
export const DescentStarterChest = new normalizr.Entity(
  'descent_starter_chests',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexIntMission = new normalizr.Entity(
  'dex_int_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexIntMissionGuard = new normalizr.Entity(
  'dex_int_mission_guards',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexIntMissionGuardMod = new normalizr.Entity(
  'dex_int_mission_guard_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexIntMissionTarget = new normalizr.Entity(
  'dex_int_mission_targets',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexMission = new normalizr.Entity(
  'dex_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexMissionMod = new normalizr.Entity(
  'dex_mission_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexMissionMonster = new normalizr.Entity(
  'dex_mission_monsters',
  {},
  {
    idAttribute: 'row',
  },
);
export const DexMissionTracking = new normalizr.Entity(
  'dex_mission_trackings',
  {},
  {
    idAttribute: 'row',
  },
);
export const DisplayMinionMonsterType = new normalizr.Entity(
  'display_minion_monster_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const DivinationCardArt = new normalizr.Entity(
  'divination_card_arts',
  {},
  {
    idAttribute: 'row',
  },
);
export const DivinationCardStashTabLayout = new normalizr.Entity(
  'divination_card_stash_tab_layouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const DropModifier = new normalizr.Entity(
  'drop_modifiers',
  {},
  {
    idAttribute: 'row',
  },
);
export const DropPool = new normalizr.Entity(
  'drop_pools',
  {},
  {
    idAttribute: 'row',
  },
);
export const EclipseMod = new normalizr.Entity(
  'eclipse_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const Effectiveness = new normalizr.Entity(
  'effectivenesses',
  {},
  {
    idAttribute: 'row',
  },
);
export const EffectivenessCostConstant = new normalizr.Entity(
  'effectiveness_cost_constants',
  {},
  {
    idAttribute: 'row',
  },
);
export const EndlessLedgeChest = new normalizr.Entity(
  'endless_ledge_chests',
  {},
  {
    idAttribute: 'row',
  },
);
export const Environment = new normalizr.Entity(
  'environments',
  {},
  {
    idAttribute: 'row',
  },
);
export const EnvironmentTransition = new normalizr.Entity(
  'environment_transitions',
  {},
  {
    idAttribute: 'row',
  },
);
export const Essence = new normalizr.Entity(
  'essences',
  {},
  {
    idAttribute: 'row',
  },
);
export const EssenceStashTabLayout = new normalizr.Entity(
  'essence_stash_tab_layouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const EssenceType = new normalizr.Entity(
  'essence_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const EventSeason = new normalizr.Entity(
  'event_seasons',
  {},
  {
    idAttribute: 'row',
  },
);
export const EventSeasonReward = new normalizr.Entity(
  'event_season_rewards',
  {},
  {
    idAttribute: 'row',
  },
);
export const EvergreenAchievement = new normalizr.Entity(
  'evergreen_achievements',
  {},
  {
    idAttribute: 'row',
  },
);
export const EvergreenAchievementType = new normalizr.Entity(
  'evergreen_achievement_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const ExperienceLevel = new normalizr.Entity(
  'experience_levels',
  {},
  {
    idAttribute: 'row',
  },
);
export const ExplodingStormBuff = new normalizr.Entity(
  'exploding_storm_buffs',
  {},
  {
    idAttribute: 'row',
  },
);
export const ExtraTerrainFeature = new normalizr.Entity(
  'extra_terrain_features',
  {},
  {
    idAttribute: 'row',
  },
);
export const ExtraTerrainFeatureFamily = new normalizr.Entity(
  'extra_terrain_feature_families',
  {},
  {
    idAttribute: 'row',
  },
);
export const Flask = new normalizr.Entity(
  'flasks',
  {},
  {
    idAttribute: 'row',
  },
);
export const FlaskType = new normalizr.Entity(
  'flask_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const FlavourText = new normalizr.Entity(
  'flavour_texts',
  {},
  {
    idAttribute: 'row',
  },
);
export const FlavourTextImage = new normalizr.Entity(
  'flavour_text_images',
  {},
  {
    idAttribute: 'row',
  },
);
export const Footprint = new normalizr.Entity(
  'footprints',
  {},
  {
    idAttribute: 'row',
  },
);
export const GameConstant = new normalizr.Entity(
  'game_constants',
  {},
  {
    idAttribute: 'row',
  },
);
export const GemTag = new normalizr.Entity(
  'gem_tags',
  {},
  {
    idAttribute: 'row',
  },
);
export const GemType = new normalizr.Entity(
  'gem_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const GlobalAudioConfig = new normalizr.Entity(
  'global_audio_configs',
  {},
  {
    idAttribute: 'row',
  },
);
export const Grandmaster = new normalizr.Entity(
  'grandmasters',
  {},
  {
    idAttribute: 'row',
  },
);
export const GrantedEffect = new normalizr.Entity(
  'granted_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const GrantedEffectGroup = new normalizr.Entity(
  'granted_effect_groups',
  {},
  {
    idAttribute: 'row',
  },
);
export const GrantedEffectsPerLevel = new normalizr.Entity(
  'granted_effects_per_levels',
  {},
  {
    idAttribute: 'row',
  },
);
export const Harbinger = new normalizr.Entity(
  'harbingers',
  {},
  {
    idAttribute: 'row',
  },
);
export const HarbingerMap = new normalizr.Entity(
  'harbinger_maps',
  {},
  {
    idAttribute: 'row',
  },
);
export const Hideout = new normalizr.Entity(
  'hideouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const HideoutDoodad = new normalizr.Entity(
  'hideout_doodads',
  {},
  {
    idAttribute: 'row',
  },
);
export const ImpactSoundDatum = new normalizr.Entity(
  'impact_sound_data',
  {},
  {
    idAttribute: 'row',
  },
);
export const IntMission = new normalizr.Entity(
  'int_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const IntMissionMod = new normalizr.Entity(
  'int_mission_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const IntMissionMonster = new normalizr.Entity(
  'int_mission_monsters',
  {},
  {
    idAttribute: 'row',
  },
);
export const InvasionMonsterGroup = new normalizr.Entity(
  'invasion_monster_groups',
  {},
  {
    idAttribute: 'row',
  },
);
export const InvasionMonsterRestriction = new normalizr.Entity(
  'invasion_monster_restrictions',
  {},
  {
    idAttribute: 'row',
  },
);
export const InvasionMonsterRole = new normalizr.Entity(
  'invasion_monster_roles',
  {},
  {
    idAttribute: 'row',
  },
);
export const InvasionMonstersPerArea = new normalizr.Entity(
  'invasion_monsters_per_areas',
  {},
  {
    idAttribute: 'row',
  },
);
export const ItemClass = new normalizr.Entity(
  'item_classes',
  {},
  {
    idAttribute: 'row',
  },
);
export const ItemClassCategory = new normalizr.Entity(
  'item_class_categories',
  {},
  {
    idAttribute: 'row',
  },
);
export const ItemExperiencePerLevel = new normalizr.Entity(
  'item_experience_per_levels',
  {},
  {
    idAttribute: 'row',
  },
);
export const ItemTheme = new normalizr.Entity(
  'item_themes',
  {},
  {
    idAttribute: 'row',
  },
);
export const ItemVisualEffect = new normalizr.Entity(
  'item_visual_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const ItemVisualIdentity = new normalizr.Entity(
  'item_visual_identities',
  {},
  {
    idAttribute: 'row',
  },
);
export const ItemisedVisualEffect = new normalizr.Entity(
  'itemised_visual_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const KillstreakThreshold = new normalizr.Entity(
  'killstreak_thresholds',
  {},
  {
    idAttribute: 'row',
  },
);
export const Labyrinth = new normalizr.Entity(
  'labyrinths',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthArea = new normalizr.Entity(
  'labyrinth_areas',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthExclusionGroup = new normalizr.Entity(
  'labyrinth_exclusion_groups',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthIzaroChest = new normalizr.Entity(
  'labyrinth_izaro_chests',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthNodeOverride = new normalizr.Entity(
  'labyrinth_node_overrides',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthReward = new normalizr.Entity(
  'labyrinth_rewards',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthRewardType = new normalizr.Entity(
  'labyrinth_reward_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthSecret = new normalizr.Entity(
  'labyrinth_secrets',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthSecretEffect = new normalizr.Entity(
  'labyrinth_secret_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthSecretLocation = new normalizr.Entity(
  'labyrinth_secret_locations',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthSection = new normalizr.Entity(
  'labyrinth_sections',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthSectionLayout = new normalizr.Entity(
  'labyrinth_section_layouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthTrial = new normalizr.Entity(
  'labyrinth_trials',
  {},
  {
    idAttribute: 'row',
  },
);
export const LabyrinthTrinket = new normalizr.Entity(
  'labyrinth_trinkets',
  {},
  {
    idAttribute: 'row',
  },
);
export const LeagueCategory = new normalizr.Entity(
  'league_categories',
  {},
  {
    idAttribute: 'row',
  },
);
export const LeagueFlag = new normalizr.Entity(
  'league_flags',
  {},
  {
    idAttribute: 'row',
  },
);
export const LeagueQuestFlag = new normalizr.Entity(
  'league_quest_flags',
  {},
  {
    idAttribute: 'row',
  },
);
export const LeagueTrophy = new normalizr.Entity(
  'league_trophies',
  {},
  {
    idAttribute: 'row',
  },
);
export const Map = new normalizr.Entity(
  'maps',
  {},
  {
    idAttribute: 'row',
  },
);
export const MapConnection = new normalizr.Entity(
  'map_connections',
  {},
  {
    idAttribute: 'row',
  },
);
export const MapDeviceRecipe = new normalizr.Entity(
  'map_device_recipes',
  {},
  {
    idAttribute: 'row',
  },
);
export const MapInhabitant = new normalizr.Entity(
  'map_inhabitants',
  {},
  {
    idAttribute: 'row',
  },
);
export const MapPin = new normalizr.Entity(
  'map_pins',
  {},
  {
    idAttribute: 'row',
  },
);
export const MapStashTabLayout = new normalizr.Entity(
  'map_stash_tab_layouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const MasterActWeight = new normalizr.Entity(
  'master_act_weights',
  {},
  {
    idAttribute: 'row',
  },
);
export const MicroMigrationDatum = new normalizr.Entity(
  'micro_migration_data',
  {},
  {
    idAttribute: 'row',
  },
);
export const MicrotransactionCharacterPortraitVariation = new normalizr.Entity(
  'microtransaction_character_portrait_variations',
  {},
  {
    idAttribute: 'row',
  },
);
export const MicrotransactionFireworksVariation = new normalizr.Entity(
  'microtransaction_fireworks_variations',
  {},
  {
    idAttribute: 'row',
  },
);
export const MicrotransactionPortalVariation = new normalizr.Entity(
  'microtransaction_portal_variations',
  {},
  {
    idAttribute: 'row',
  },
);
export const MicrotransactionSlotId = new normalizr.Entity(
  'microtransaction_slot_ids',
  {},
  {
    idAttribute: 'row',
  },
);
export const MicrotransactionSocialFrameVariation = new normalizr.Entity(
  'microtransaction_social_frame_variations',
  {},
  {
    idAttribute: 'row',
  },
);
export const MinimapIcon = new normalizr.Entity(
  'minimap_icons',
  {},
  {
    idAttribute: 'row',
  },
);
export const MiscAnimated = new normalizr.Entity(
  'misc_animateds',
  {},
  {
    idAttribute: 'row',
  },
);
export const MiscBeam = new normalizr.Entity(
  'misc_beams',
  {},
  {
    idAttribute: 'row',
  },
);
export const MiscObject = new normalizr.Entity(
  'misc_objects',
  {},
  {
    idAttribute: 'row',
  },
);
export const MissionTileMap = new normalizr.Entity(
  'mission_tile_maps',
  {},
  {
    idAttribute: 'row',
  },
);
export const MissionTransitionTile = new normalizr.Entity(
  'mission_transition_tiles',
  {},
  {
    idAttribute: 'row',
  },
);
export const Mod = new normalizr.Entity(
  'mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const ModAuraFlag = new normalizr.Entity(
  'mod_aura_flags',
  {},
  {
    idAttribute: 'row',
  },
);
export const ModDomain = new normalizr.Entity(
  'mod_domains',
  {},
  {
    idAttribute: 'row',
  },
);
export const ModFamily = new normalizr.Entity(
  'mod_families',
  {},
  {
    idAttribute: 'row',
  },
);
export const ModGenerationType = new normalizr.Entity(
  'mod_generation_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const ModSellPrice = new normalizr.Entity(
  'mod_sell_prices',
  {},
  {
    idAttribute: 'row',
  },
);
export const ModSellPriceType = new normalizr.Entity(
  'mod_sell_price_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const ModType = new normalizr.Entity(
  'mod_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterAdditionalMonsterDrop = new normalizr.Entity(
  'monster_additional_monster_drops',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterArmour = new normalizr.Entity(
  'monster_armours',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterBehavior = new normalizr.Entity(
  'monster_behaviors',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterFleeCondition = new normalizr.Entity(
  'monster_flee_conditions',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterGroupEntry = new normalizr.Entity(
  'monster_group_entries',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterGroupName = new normalizr.Entity(
  'monster_group_names',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterMapBossDifficulty = new normalizr.Entity(
  'monster_map_boss_difficulties',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterMapDifficulty = new normalizr.Entity(
  'monster_map_difficulties',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterPack = new normalizr.Entity(
  'monster_packs',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterPackEntry = new normalizr.Entity(
  'monster_pack_entries',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterResistance = new normalizr.Entity(
  'monster_resistances',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterScalingByLevel = new normalizr.Entity(
  'monster_scaling_by_levels',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterSegment = new normalizr.Entity(
  'monster_segments',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterSize = new normalizr.Entity(
  'monster_sizes',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterSpawnerOverride = new normalizr.Entity(
  'monster_spawner_overrides',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterType = new normalizr.Entity(
  'monster_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const MonsterVariety = new normalizr.Entity(
  'monster_varieties',
  {},
  {
    idAttribute: 'row',
  },
);
export const Music = new normalizr.Entity(
  'music',
  {},
  {
    idAttribute: 'row',
  },
);
export const MysteryBox = new normalizr.Entity(
  'mystery_boxes',
  {},
  {
    idAttribute: 'row',
  },
);
export const MysteryPack = new normalizr.Entity(
  'mystery_packs',
  {},
  {
    idAttribute: 'row',
  },
);
export const MysteryPackItem = new normalizr.Entity(
  'mystery_pack_items',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPC = new normalizr.Entity(
  'n_p_cs',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPCAudio = new normalizr.Entity(
  'n_p_c_audios',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPCMaster = new normalizr.Entity(
  'n_p_c_masters',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPCMasterExperiencePerLevel = new normalizr.Entity(
  'n_p_c_master_experience_per_levels',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPCShop = new normalizr.Entity(
  'n_p_c_shops',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPCTalk = new normalizr.Entity(
  'n_p_c_talks',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPCTalkCategory = new normalizr.Entity(
  'n_p_c_talk_categories',
  {},
  {
    idAttribute: 'row',
  },
);
export const NPCTextAudio = new normalizr.Entity(
  'n_p_c_text_audios',
  {},
  {
    idAttribute: 'row',
  },
);
export const Notification = new normalizr.Entity(
  'notifications',
  {},
  {
    idAttribute: 'row',
  },
);
export const OldMapStashTabLayout = new normalizr.Entity(
  'old_map_stash_tab_layouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const Orientation = new normalizr.Entity(
  'orientations',
  {},
  {
    idAttribute: 'row',
  },
);
export const PVPType = new normalizr.Entity(
  'p_v_p_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const PantheonPanelLayout = new normalizr.Entity(
  'pantheon_panel_layouts',
  {},
  {
    idAttribute: 'row',
  },
);
export const PantheonSoul = new normalizr.Entity(
  'pantheon_souls',
  {},
  {
    idAttribute: 'row',
  },
);
export const PassiveJewelSlot = new normalizr.Entity(
  'passive_jewel_slots',
  {},
  {
    idAttribute: 'row',
  },
);
export const PassiveSkill = new normalizr.Entity(
  'passive_skills',
  {},
  {
    idAttribute: 'row',
  },
);
export const PathOfEndurance = new normalizr.Entity(
  'path_of_endurances',
  {},
  {
    idAttribute: 'row',
  },
);
export const PerLevelValue = new normalizr.Entity(
  'per_level_values',
  {},
  {
    idAttribute: 'row',
  },
);
export const PerandusBoss = new normalizr.Entity(
  'perandus_bosses',
  {},
  {
    idAttribute: 'row',
  },
);
export const PerandusChest = new normalizr.Entity(
  'perandus_chests',
  {},
  {
    idAttribute: 'row',
  },
);
export const PerandusDaemon = new normalizr.Entity(
  'perandus_daemons',
  {},
  {
    idAttribute: 'row',
  },
);
export const PerandusGuard = new normalizr.Entity(
  'perandus_guards',
  {},
  {
    idAttribute: 'row',
  },
);
export const Pet = new normalizr.Entity(
  'pets',
  {},
  {
    idAttribute: 'row',
  },
);
export const PreloadGroup = new normalizr.Entity(
  'preload_groups',
  {},
  {
    idAttribute: 'row',
  },
);
export const PreloadPriority = new normalizr.Entity(
  'preload_priorities',
  {},
  {
    idAttribute: 'row',
  },
);
export const Projectile = new normalizr.Entity(
  'projectiles',
  {},
  {
    idAttribute: 'row',
  },
);
export const ProjectileVariation = new normalizr.Entity(
  'projectile_variations',
  {},
  {
    idAttribute: 'row',
  },
);
export const Prophecy = new normalizr.Entity(
  'prophecies',
  {},
  {
    idAttribute: 'row',
  },
);
export const ProphecyChain = new normalizr.Entity(
  'prophecy_chains',
  {},
  {
    idAttribute: 'row',
  },
);
export const ProphecyType = new normalizr.Entity(
  'prophecy_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const Quest = new normalizr.Entity(
  'quests',
  {},
  {
    idAttribute: 'row',
  },
);
export const QuestAchievement = new normalizr.Entity(
  'quest_achievements',
  {},
  {
    idAttribute: 'row',
  },
);
export const QuestFlag = new normalizr.Entity(
  'quest_flags',
  {},
  {
    idAttribute: 'row',
  },
);
export const QuestReward = new normalizr.Entity(
  'quest_rewards',
  {},
  {
    idAttribute: 'row',
  },
);
export const QuestState = new normalizr.Entity(
  'quest_states',
  {},
  {
    idAttribute: 'row',
  },
);
export const QuestStaticReward = new normalizr.Entity(
  'quest_static_rewards',
  {},
  {
    idAttribute: 'row',
  },
);
export const QuestVendorReward = new normalizr.Entity(
  'quest_vendor_rewards',
  {},
  {
    idAttribute: 'row',
  },
);
export const Race = new normalizr.Entity(
  'races',
  {},
  {
    idAttribute: 'row',
  },
);
export const RaceArea = new normalizr.Entity(
  'race_areas',
  {},
  {
    idAttribute: 'row',
  },
);
export const RaceTime = new normalizr.Entity(
  'race_times',
  {},
  {
    idAttribute: 'row',
  },
);
export const RandomUniqueMonster = new normalizr.Entity(
  'random_unique_monsters',
  {},
  {
    idAttribute: 'row',
  },
);
export const Rarity = new normalizr.Entity(
  'rarities',
  {},
  {
    idAttribute: 'row',
  },
);
export const Realm = new normalizr.Entity(
  'realms',
  {},
  {
    idAttribute: 'row',
  },
);
export const RelativeImportanceConstant = new normalizr.Entity(
  'relative_importance_constants',
  {},
  {
    idAttribute: 'row',
  },
);
export const RogueExile = new normalizr.Entity(
  'rogue_exiles',
  {},
  {
    idAttribute: 'row',
  },
);
export const RunicCircle = new normalizr.Entity(
  'runic_circles',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShieldType = new normalizr.Entity(
  'shield_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopCategory = new normalizr.Entity(
  'shop_categories',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopCountry = new normalizr.Entity(
  'shop_countries',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopCurrency = new normalizr.Entity(
  'shop_currencies',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopItem = new normalizr.Entity(
  'shop_items',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopItemPrice = new normalizr.Entity(
  'shop_item_prices',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopPackagePlatform = new normalizr.Entity(
  'shop_package_platforms',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopPaymentPackage = new normalizr.Entity(
  'shop_payment_packages',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopPaymentPackageItem = new normalizr.Entity(
  'shop_payment_package_items',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopPaymentPackagePrice = new normalizr.Entity(
  'shop_payment_package_prices',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopRegion = new normalizr.Entity(
  'shop_regions',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShopToken = new normalizr.Entity(
  'shop_tokens',
  {},
  {
    idAttribute: 'row',
  },
);
export const Shrine = new normalizr.Entity(
  'shrines',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShrineBuff = new normalizr.Entity(
  'shrine_buffs',
  {},
  {
    idAttribute: 'row',
  },
);
export const ShrineSound = new normalizr.Entity(
  'shrine_sounds',
  {},
  {
    idAttribute: 'row',
  },
);
export const SkillGem = new normalizr.Entity(
  'skill_gems',
  {},
  {
    idAttribute: 'row',
  },
);
export const SkillTotem = new normalizr.Entity(
  'skill_totems',
  {},
  {
    idAttribute: 'row',
  },
);
export const SkillTotemVariation = new normalizr.Entity(
  'skill_totem_variations',
  {},
  {
    idAttribute: 'row',
  },
);
export const SoundEffect = new normalizr.Entity(
  'sound_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const Stat = new normalizr.Entity(
  'stats',
  {},
  {
    idAttribute: 'row',
  },
);
export const StatDescriptionFunction = new normalizr.Entity(
  'stat_description_functions',
  {},
  {
    idAttribute: 'row',
  },
);
export const StatInterpolationType = new normalizr.Entity(
  'stat_interpolation_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const StatSemantic = new normalizr.Entity(
  'stat_semantics',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexIntMission = new normalizr.Entity(
  'str_dex_int_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexIntMissionExtraRequirement = new normalizr.Entity(
  'str_dex_int_mission_extra_requirements',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexIntMissionMap = new normalizr.Entity(
  'str_dex_int_mission_maps',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexIntMissionMod = new normalizr.Entity(
  'str_dex_int_mission_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexIntMissionUniqueMap = new normalizr.Entity(
  'str_dex_int_mission_unique_maps',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexMission = new normalizr.Entity(
  'str_dex_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexMissionArchetype = new normalizr.Entity(
  'str_dex_mission_archetypes',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexMissionMod = new normalizr.Entity(
  'str_dex_mission_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrDexMissionSpecialMod = new normalizr.Entity(
  'str_dex_mission_special_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrIntMission = new normalizr.Entity(
  'str_int_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrIntMissionMonsterWave = new normalizr.Entity(
  'str_int_mission_monster_waves',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrIntMissionRelicMod = new normalizr.Entity(
  'str_int_mission_relic_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrIntMissionRelicPattern = new normalizr.Entity(
  'str_int_mission_relic_patterns',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrMission = new normalizr.Entity(
  'str_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrMissionBoss = new normalizr.Entity(
  'str_mission_bosses',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrMissionMapMod = new normalizr.Entity(
  'str_mission_map_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrMissionMapModNumber = new normalizr.Entity(
  'str_mission_map_mod_numbers',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrMissionSpiritEffect = new normalizr.Entity(
  'str_mission_spirit_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const StrMissionSpiritSecondaryEffect = new normalizr.Entity(
  'str_mission_spirit_secondary_effects',
  {},
  {
    idAttribute: 'row',
  },
);
export const Strongbox = new normalizr.Entity(
  'strongboxes',
  {},
  {
    idAttribute: 'row',
  },
);
export const SummonedSpecificBarrel = new normalizr.Entity(
  'summoned_specific_barrels',
  {},
  {
    idAttribute: 'row',
  },
);
export const SummonedSpecificMonster = new normalizr.Entity(
  'summoned_specific_monsters',
  {},
  {
    idAttribute: 'row',
  },
);
export const SummonedSpecificMonstersOnDeath = new normalizr.Entity(
  'summoned_specific_monsters_on_deaths',
  {},
  {
    idAttribute: 'row',
  },
);
export const SupporterPackSet = new normalizr.Entity(
  'supporter_pack_sets',
  {},
  {
    idAttribute: 'row',
  },
);
export const Tag = new normalizr.Entity(
  'tags',
  {},
  {
    idAttribute: 'row',
  },
);
export const Talisman = new normalizr.Entity(
  'talismans',
  {},
  {
    idAttribute: 'row',
  },
);
export const TalismanMonsterMod = new normalizr.Entity(
  'talisman_monster_mods',
  {},
  {
    idAttribute: 'row',
  },
);
export const TalismanPack = new normalizr.Entity(
  'talisman_packs',
  {},
  {
    idAttribute: 'row',
  },
);
export const TerrainPlugin = new normalizr.Entity(
  'terrain_plugins',
  {},
  {
    idAttribute: 'row',
  },
);
export const Tip = new normalizr.Entity(
  'tips',
  {},
  {
    idAttribute: 'row',
  },
);
export const Topology = new normalizr.Entity(
  'topologies',
  {},
  {
    idAttribute: 'row',
  },
);
export const TormentSpirit = new normalizr.Entity(
  'torment_spirits',
  {},
  {
    idAttribute: 'row',
  },
);
export const TriggerSpawner = new normalizr.Entity(
  'trigger_spawners',
  {},
  {
    idAttribute: 'row',
  },
);
export const Tutorial = new normalizr.Entity(
  'tutorials',
  {},
  {
    idAttribute: 'row',
  },
);
export const UniqueChest = new normalizr.Entity(
  'unique_chests',
  {},
  {
    idAttribute: 'row',
  },
);
export const UniqueFragment = new normalizr.Entity(
  'unique_fragments',
  {},
  {
    idAttribute: 'row',
  },
);
export const UniqueJewelLimit = new normalizr.Entity(
  'unique_jewel_limits',
  {},
  {
    idAttribute: 'row',
  },
);
export const UniqueSet = new normalizr.Entity(
  'unique_sets',
  {},
  {
    idAttribute: 'row',
  },
);
export const UniqueSetName = new normalizr.Entity(
  'unique_set_names',
  {},
  {
    idAttribute: 'row',
  },
);
export const VoteState = new normalizr.Entity(
  'vote_states',
  {},
  {
    idAttribute: 'row',
  },
);
export const VoteType = new normalizr.Entity(
  'vote_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const WarbandsGraph = new normalizr.Entity(
  'warbands_graphs',
  {},
  {
    idAttribute: 'row',
  },
);
export const WarbandsMapGraph = new normalizr.Entity(
  'warbands_map_graphs',
  {},
  {
    idAttribute: 'row',
  },
);
export const WarbandsPackMonster = new normalizr.Entity(
  'warbands_pack_monsters',
  {},
  {
    idAttribute: 'row',
  },
);
export const WarbandsPackNumber = new normalizr.Entity(
  'warbands_pack_numbers',
  {},
  {
    idAttribute: 'row',
  },
);
export const WeaponArmourCommon = new normalizr.Entity(
  'weapon_armour_commons',
  {},
  {
    idAttribute: 'row',
  },
);
export const WeaponClass = new normalizr.Entity(
  'weapon_classes',
  {},
  {
    idAttribute: 'row',
  },
);
export const WeaponDamageScaling = new normalizr.Entity(
  'weapon_damage_scalings',
  {},
  {
    idAttribute: 'row',
  },
);
export const WeaponImpactSoundDatum = new normalizr.Entity(
  'weapon_impact_sound_data',
  {},
  {
    idAttribute: 'row',
  },
);
export const WeaponSoundType = new normalizr.Entity(
  'weapon_sound_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const WeaponType = new normalizr.Entity(
  'weapon_types',
  {},
  {
    idAttribute: 'row',
  },
);
export const Word = new normalizr.Entity(
  'words',
  {},
  {
    idAttribute: 'row',
  },
);
export const Wordlist = new normalizr.Entity(
  'wordlists',
  {},
  {
    idAttribute: 'row',
  },
);
export const WorldArea = new normalizr.Entity(
  'world_areas',
  {},
  {
    idAttribute: 'row',
  },
);
export const XPPerLevelForMission = new normalizr.Entity(
  'x_p_per_level_for_missions',
  {},
  {
    idAttribute: 'row',
  },
);
export const ZanaQuest = new normalizr.Entity(
  'zana_quests',
  {},
  {
    idAttribute: 'row',
  },
);
Achievement.define({
  achievement_sets_display: AchievementSetsDisplay,
});
AchievementItem.define({
  achievement: Achievement,
});
AchievementSet.define({});
AchievementSetReward.define({
  achievement_sets_display: AchievementSetsDisplay,
  base_item_type: BaseItemType,
});
AchievementSetsDisplay.define({});
ActiveSkill.define({
  weapon_restriction_item_classes: [ItemClass],
  input_stat: [Stat],
  output_stat: [Stat],
});
ActiveSkillTargetType.define({});
ActiveSkillType.define({});
AreaTransitionAnimation.define({});
AreaTransitionAnimationType.define({});
AreaTransitionInfo.define({});
AreaType.define({});
ArmourClass.define({});
ArmourSurfaceType.define({});
ArmourType.define({
  base_item_type: BaseItemType,
});
Ascendancy.define({
  character: Character,
});
AtlasNode.define({
  world_area: WorldArea,
  default_item_visual_identity: ItemVisualIdentity,
  shaped_item_visual_identity: ItemVisualIdentity,
  atlas_node: [AtlasNode],
});
AtlasQuestItem.define({
  base_item_type: BaseItemType,
  world_area: WorldArea,
});
Attribute.define({});
BackendError.define({});
BaseItemType.define({
  item_class: ItemClass,
  flavour_text: FlavourText,
  sound_effect: SoundEffect,
  item_visual_identity: ItemVisualIdentity,
  equip_achievement_item: AchievementItem,
  implicit_mods: [Mod],
  normal_purchase_base_item_types: [BaseItemType],
  magic_purchase_base_item_types: [BaseItemType],
  tags: [Tag],
  vendor_recipe_achievement_items: [AchievementItem],
  rare_purchase_base_item_types: [BaseItemType],
  unique_purchase_base_item_types: [BaseItemType],
});
BeyondDemon.define({
  monster_variety: MonsterVariety,
});
BindableVirtualKey.define({});
BloodType.define({});
Bloodline.define({
  buff_definition: BuffDefinition,
  monster_variety: MonsterVariety,
  mods: [Mod],
  spawn_weight_tags: [Tag],
  item_weight_tags: [Tag],
});
BuffCategory.define({});
BuffDefinition.define({
  maximum_stat: Stat,
  current_stat: Stat,
  buff_visual: BuffVisual,
  stats: [Stat],
});
BuffGroup.define({});
BuffMergeMode.define({});
BuffVisual.define({
  misc_animated: MiscAnimated,
  misc_animated2: MiscAnimated,
  preload_groups: [PreloadGroup],
});
BuffVisualOrbType.define({});
Character.define({
  start_skill_gem_base_item_type: BaseItemType,
  start_weapon_base_item_type: BaseItemType,
});
CharacterAudioEvent.define({
  marauder_character_text_audio: [CharacterTextAudio],
  ranger_character_text_audio: [CharacterTextAudio],
  witch_character_text_audio: [CharacterTextAudio],
  duelist_character_text_audio: [CharacterTextAudio],
  shadow_character_text_audio: [CharacterTextAudio],
  templar_character_text_audio: [CharacterTextAudio],
  scion_character_text_audio: [CharacterTextAudio],
  goddess_character_text_audio: [CharacterTextAudio],
  jack_the_axe_character_text_audio: [CharacterTextAudio],
});
CharacterPanelDescriptionMode.define({});
CharacterPanelStat.define({
  character_panel_description_mode: CharacterPanelDescriptionMode,
  character_panel_tab: CharacterPanelTab,
  stats1: [Stat],
  stats2: [Stat],
  stats3: [Stat],
});
CharacterPanelStatContext.define({});
CharacterPanelTab.define({});
CharacterStartItem.define({
  character_start_state: CharacterStartState,
  base_item_type: BaseItemType,
  socketed_skill_gems: [SkillGem],
  mods: [Mod],
});
CharacterStartQuestState.define({
  quest: [Quest],
  map_pins: [MapPin],
});
CharacterStartState.define({
  character: Character,
  character_start_state_set: CharacterStartStateSet,
  passive_skills: [PassiveSkill],
  character_start_quest_state: [CharacterStartQuestState],
});
CharacterStartStateSet.define({});
CharacterTextAudio.define({});
Chest.define({
  base_item_type: BaseItemType,
  chest_effect: ChestEffect,
  corrupt_achievement_item: AchievementItem,
  currency_use_achievement_item: AchievementItem,
  mods: [Mod],
  tags: [Tag],
  encounter_achievement_items: [AchievementItem],
});
ChestCluster.define({
  chests: [Chest],
});
ChestEffect.define({});
ClientString.define({});
CloneShotVariation.define({
  monster_variety: MonsterVariety,
});
Command.define({});
ComponentArmour.define({
  base_item_type: BaseItemType,
});
ComponentAttributeRequirement.define({
  base_item_type: BaseItemType,
});
ComponentCharge.define({
  base_item_type: BaseItemType,
});
CooldownBypassType.define({});
CooldownGroup.define({});
CraftingBenchCustomAction.define({});
CraftingBenchOption.define({
  npc_master: NPCMaster,
  mod: Mod,
  cost_base_item_types: [BaseItemType],
  item_classes: [ItemClass],
});
CurrencyItem.define({
  base_item_type: BaseItemType,
  full_stack_base_item_type: BaseItemType,
  possession_achievement_item: AchievementItem,
  usage_achievement_items: [AchievementItem],
});
CurrencyStashTabLayout.define({
  base_item_type: BaseItemType,
});
CurrencyUseType.define({});
DailyMission.define({
  npc_talk: NPCTalk,
  pvp_type: PVPType,
  characters: [Character],
});
DailyOverride.define({
  daily_missionss: DailyMission,
});
DamageParticleEffect.define({});
Dance.define({
  base_item_type: BaseItemType,
  character: Character,
});
DaressoPitFight.define({});
Default.define({});
DefaultMonsterStat.define({});
DescentExile.define({
  world_area: WorldArea,
  character: Character,
  monster_variety: MonsterVariety,
});
DescentRewardChest.define({
  world_area: WorldArea,
  base_item_types1: [BaseItemType],
  base_item_types2: [BaseItemType],
  base_item_types3: [BaseItemType],
  base_item_types4: [BaseItemType],
  base_item_types5: [BaseItemType],
  base_item_types6: [BaseItemType],
  base_item_types7: [BaseItemType],
  base_item_types8: [BaseItemType],
  base_item_types9: [BaseItemType],
  base_item_types10: [BaseItemType],
  base_item_types11: [BaseItemType],
  base_item_types12: [BaseItemType],
  base_item_types13: [BaseItemType],
  base_item_types14: [BaseItemType],
});
DescentStarterChest.define({
  character: Character,
  base_item_type: BaseItemType,
  world_area: WorldArea,
});
DexIntMission.define({
  hostage_monster_variety: MonsterVariety,
  npc_talk: NPCTalk,
  achievement_items: [AchievementItem],
});
DexIntMissionGuard.define({
  monster_pack: MonsterPack,
});
DexIntMissionGuardMod.define({});
DexIntMissionTarget.define({
  monster_variety: MonsterVariety,
});
DexMission.define({});
DexMissionMod.define({
  mods: [Mod],
});
DexMissionMonster.define({
  boss_monster_variety: MonsterVariety,
  monster_packs: [MonsterPack],
  monster_varieties: [MonsterVariety],
});
DexMissionTracking.define({
  npc_talk: NPCTalk,
});
DisplayMinionMonsterType.define({
  monster_variety: MonsterVariety,
});
DivinationCardArt.define({
  base_item_type: BaseItemType,
});
DivinationCardStashTabLayout.define({
  base_item_type: BaseItemType,
});
DropModifier.define({});
DropPool.define({});
EclipseMod.define({
  mod: Mod,
  spawn_weight_tags: [Tag],
});
Effectiveness.define({});
EffectivenessCostConstant.define({});
EndlessLedgeChest.define({
  world_area: WorldArea,
  base_item_types: [BaseItemType],
});
Environment.define({
  environment_transition: EnvironmentTransition,
  music: [Music],
  corrupted_music: [Music],
});
EnvironmentTransition.define({});
Essence.define({
  base_item_type: BaseItemType,
  mods1: Mod,
  mods2: Mod,
  quiver_mod: Mod,
  amulet1_mod: Mod,
  belt1_mod: Mod,
  belt3_mod: Mod,
  gloves1_mod: Mod,
  boots1_mod: Mod,
  body_armour1_mod: Mod,
  helmet1_mod: Mod,
  shield1_mod: Mod,
  essence_type: EssenceType,
  '1_hand_mods1': Mod,
  mods13: Mod,
  mods14: Mod,
  mods15: Mod,
  '2_hand_mods1': Mod,
  boots3_mod: Mod,
  ranged_mod: Mod,
  helmet2_mod: Mod,
  body_armour2_mod: Mod,
  boots2_mod: Mod,
  gloves2_mod: Mod,
  bow_mod: Mod,
  wand_mod: Mod,
  '2_hand_mods2': Mod,
  '2_hand_mods3': Mod,
  '2_hand_mods4': Mod,
  '2_hand_mods5': Mod,
  '1_hand_mods2': Mod,
  '1_hand_mods3': Mod,
  '1_hand_mods4': Mod,
  '1_hand_mods5': Mod,
  '1_hand_mods6': Mod,
  '1_hand_mods7': Mod,
  '1_hand_mods8': Mod,
  '1_hand_mods9': Mod,
  belt2_mod: Mod,
  amulet2_mod: Mod,
  ring_mod: Mod,
  mods41: Mod,
  shield2_mod: Mod,
  mods43: Mod,
  monster_mods: [Mod],
});
EssenceStashTabLayout.define({
  base_item_type: BaseItemType,
});
EssenceType.define({
  word: Word,
});
EventSeason.define({});
EventSeasonReward.define({
  event_season: EventSeason,
});
EvergreenAchievement.define({});
EvergreenAchievementType.define({});
ExperienceLevel.define({});
ExplodingStormBuff.define({
  buff_definitions1: BuffDefinition,
  friendly_monster_variety: MonsterVariety,
  misc_object: MiscObject,
  misc_animated: MiscAnimated,
  buff_visual: BuffVisual,
  enemy_monster_variety: MonsterVariety,
  buff_definitions2: BuffDefinition,
});
ExtraTerrainFeature.define({});
ExtraTerrainFeatureFamily.define({});
Flask.define({
  base_item_type: BaseItemType,
  buff_definition: BuffDefinition,
});
FlaskType.define({});
FlavourText.define({});
FlavourTextImage.define({});
Footprint.define({});
GameConstant.define({});
GemTag.define({});
GemType.define({});
GlobalAudioConfig.define({});
Grandmaster.define({
  mods: [Mod],
});
GrantedEffect.define({
  active_skill: ActiveSkill,
});
GrantedEffectGroup.define({});
GrantedEffectsPerLevel.define({
  granted_effect: GrantedEffect,
  stats: [Stat],
  effectiveness_cost_constants: [EffectivenessCostConstant],
  quality_stats: [Stat],
  stats2: [Stat],
});
Harbinger.define({
  monster_variety: MonsterVariety,
});
HarbingerMap.define({
  base_item_type: BaseItemType,
});
Hideout.define({
  small_world_area: WorldArea,
  npc_master: NPCMaster,
  medium_world_area: WorldArea,
  large_world_area: WorldArea,
});
HideoutDoodad.define({
  base_item_type: BaseItemType,
  npc_master: NPCMaster,
});
ImpactSoundDatum.define({});
IntMission.define({
  npc_talk: NPCTalk,
  monster_variety: MonsterVariety,
});
IntMissionMod.define({
  monster_variety: MonsterVariety,
  mods: [Mod],
});
IntMissionMonster.define({
  objective_monster_varieties: [MonsterVariety],
  achievement_items: [AchievementItem],
});
InvasionMonsterGroup.define({});
InvasionMonsterRestriction.define({
  world_area: WorldArea,
  monster_varieties: [MonsterVariety],
});
InvasionMonsterRole.define({});
InvasionMonstersPerArea.define({
  world_area: WorldArea,
  monster_varieties1: [MonsterVariety],
  monster_varieties2: [MonsterVariety],
});
ItemClass.define({});
ItemClassCategory.define({});
ItemExperiencePerLevel.define({
  base_item_type: BaseItemType,
});
ItemTheme.define({});
ItemVisualEffect.define({});
ItemVisualIdentity.define({
  sound_effect: SoundEffect,
  create_corrupted_jewel_achievement_item: AchievementItem,
  pickup_achievement_items: [AchievementItem],
  identify_achievement_items: [AchievementItem],
  corrupt_achievement_items: [AchievementItem],
});
ItemisedVisualEffect.define({
  base_item_type: BaseItemType,
  item_visual_effect: ItemVisualEffect,
  item_visual_identity1: ItemVisualIdentity,
  item_visual_identity2: ItemVisualIdentity,
});
KillstreakThreshold.define({
  monster_variety: MonsterVariety,
  achievement_item: AchievementItem,
});
Labyrinth.define({});
LabyrinthArea.define({
  normal_world_areas: [WorldArea],
  cruel_world_areas: [WorldArea],
  merciless_world_areas: [WorldArea],
  endgame_world_areas: [WorldArea],
});
LabyrinthExclusionGroup.define({});
LabyrinthIzaroChest.define({
  chest: Chest,
});
LabyrinthNodeOverride.define({});
LabyrinthReward.define({
  chest: Chest,
  labyrinth_reward_type: LabyrinthRewardType,
});
LabyrinthRewardType.define({});
LabyrinthSecret.define({
  achievement_item: AchievementItem,
  labyrinth_secret_effects0: [LabyrinthSecretEffect],
  labyrinth_secret_effects1: [LabyrinthSecretEffect],
  labyrinth_secret_effects2: [LabyrinthSecretEffect],
  labyrinth_secret_effects3: [LabyrinthSecretEffect],
});
LabyrinthSecretEffect.define({
  monster_variety: MonsterVariety,
  buff_buff_definition: BuffDefinition,
});
LabyrinthSecretLocation.define({});
LabyrinthSection.define({});
LabyrinthSectionLayout.define({
  labyrinth_section: LabyrinthSection,
  labyrinth_secrets0: LabyrinthSecret,
  labyrinth_secrets1: LabyrinthSecret,
  labyrinth_area: LabyrinthArea,
  labyrinth_section_layout: [LabyrinthSectionLayout],
  labyrinth_node_overrides: [LabyrinthNodeOverride],
});
LabyrinthTrial.define({
  npc_text_audio: NPCTextAudio,
});
LabyrinthTrinket.define({
  base_item_type: BaseItemType,
  buff_buff_definition: BuffDefinition,
  labyrinth_secrets: [LabyrinthSecret],
});
LeagueCategory.define({});
LeagueFlag.define({});
LeagueQuestFlag.define({});
LeagueTrophy.define({});
Map.define({
  base_item_type: BaseItemType,
  regular_world_area: WorldArea,
  unique_world_area: WorldArea,
  map_upgrade_base_item_type: BaseItemType,
  shaped_base_map: Map,
  maps1: Map,
  maps2: Map,
  maps3: Map,
  monster_packs: [MonsterPack],
  higher_tier_maps_base_item_types: [BaseItemType],
});
MapConnection.define({
  map_pins0: MapPin,
  map_pins1: MapPin,
});
MapDeviceRecipe.define({
  world_area: WorldArea,
  base_item_types: [BaseItemType],
});
MapInhabitant.define({
  stat: Stat,
  monster_packs: [MonsterPack],
});
MapPin.define({
  waypoint_world_area: WorldArea,
  world_areas: [WorldArea],
});
MapStashTabLayout.define({});
MasterActWeight.define({
  npc_master: NPCMaster,
});
MicroMigrationDatum.define({
  base_item_type: BaseItemType,
});
MicrotransactionCharacterPortraitVariation.define({});
MicrotransactionFireworksVariation.define({
  base_item_type: BaseItemType,
});
MicrotransactionPortalVariation.define({
  base_item_type: BaseItemType,
});
MicrotransactionSlotId.define({});
MicrotransactionSocialFrameVariation.define({
  base_item_type: BaseItemType,
});
MinimapIcon.define({});
MiscAnimated.define({
  preload_groups: [PreloadGroup],
});
MiscBeam.define({
  preload_groups: [PreloadGroup],
});
MiscObject.define({
  preload_groups: [PreloadGroup],
});
MissionTileMap.define({
  npc_master: NPCMaster,
  mission_transition_tile: MissionTransitionTile,
  world_areas: [WorldArea],
});
MissionTransitionTile.define({});
Mod.define({
  mod_type: ModType,
  stats1: Stat,
  stats2: Stat,
  stats3: Stat,
  stats4: Stat,
  buff_definition: BuffDefinition,
  granted_effects_per_level: GrantedEffectsPerLevel,
  stats5: Stat,
  achievement_item: AchievementItem,
  spawn_weight_tags: [Tag],
  tags: [Tag],
  generation_weight_tags: [Tag],
});
ModAuraFlag.define({});
ModDomain.define({});
ModFamily.define({});
ModGenerationType.define({});
ModSellPrice.define({
  mod_sell_price_type: ModSellPriceType,
  base_item_types: [BaseItemType],
});
ModSellPriceType.define({});
ModType.define({
  mod_sell_prices: [ModSellPrice],
});
MonsterAdditionalMonsterDrop.define({
  monster_variety: MonsterVariety,
});
MonsterArmour.define({});
MonsterBehavior.define({});
MonsterFleeCondition.define({});
MonsterGroupEntry.define({
  monster_variety: MonsterVariety,
});
MonsterGroupName.define({});
MonsterMapBossDifficulty.define({
  stats1: Stat,
  stats2: Stat,
  stats3: Stat,
  stats4: Stat,
});
MonsterMapDifficulty.define({
  stats1: Stat,
  stats2: Stat,
  stats3: Stat,
  stats4: Stat,
});
MonsterPack.define({
  world_areas: [WorldArea],
  boss_monster_monster_varieties: [MonsterVariety],
  tags: [Tag],
});
MonsterPackEntry.define({
  monster_pack: MonsterPack,
  monster_variety: MonsterVariety,
});
MonsterResistance.define({});
MonsterScalingByLevel.define({});
MonsterSegment.define({});
MonsterSize.define({});
MonsterSpawnerOverride.define({
  base_monster_variety: MonsterVariety,
  override_monster_variety: MonsterVariety,
});
MonsterType.define({
  monster_resistance: MonsterResistance,
  tags: [Tag],
});
MonsterVariety.define({
  monster_type: MonsterType,
  back_item_visual_identity: ItemVisualIdentity,
  main_hand_item_class: ItemClass,
  off_hand_item_class: ItemClass,
  helmet_item_visual_identity: ItemVisualIdentity,
  kill_while_onslaught_is_active_achievement_item: AchievementItem,
  monster_segment: MonsterSegment,
  monster_armour: MonsterArmour,
  kill_while_talisman_is_active_achievement_item: AchievementItem,
  mods: [Mod],
  tags: [Tag],
  granted_effects: [GrantedEffect],
  mods2: [Mod],
  weapon1_item_visual_identity: [ItemVisualIdentity],
  weapon2_item_visual_identity: [ItemVisualIdentity],
  kill_specific_monster_count_achievement_items: [AchievementItem],
  special_mods: [Mod],
  kill_rare_achievement_items: [AchievementItem],
  monster_level80_achievement_items: [AchievementItem],
  part1_mods: [Mod],
  part2_mods: [Mod],
  endgame_mods: [Mod],
  kill_rare_in_part2_achievement_items: [AchievementItem],
  kill_rare_in_endgame_achievement_items: [AchievementItem],
  kill_specific_monster_count2_achievement_items: [AchievementItem],
});
Music.define({});
MysteryBox.define({
  base_item_type: BaseItemType,
});
MysteryPack.define({});
MysteryPackItem.define({});
NPC.define({
  npc_master: NPCMaster,
  npc_shop: NPCShop,
  npc_audio1: NPCAudio,
  npc_audio2: NPCAudio,
});
NPCAudio.define({});
NPCMaster.define({
  npc: NPC,
  signature_mod_mod: Mod,
  talisman_achievement_item: AchievementItem,
  achievement_items: [AchievementItem],
  signature_mod_spawn_weight_tags: [Tag],
  unknown_weight_tags: [Tag],
  master_level5_achievement_items: [AchievementItem],
});
NPCMasterExperiencePerLevel.define({
  npc_master: NPCMaster,
});
NPCShop.define({
  sold_item_tags: [Tag],
});
NPCTalk.define({
  npc: NPC,
  quest: Quest,
  base_item_type: BaseItemType,
  npc_text_audio: [NPCTextAudio],
  prophecies: [Prophecy],
});
NPCTalkCategory.define({});
NPCTextAudio.define({
  character: Character,
});
Notification.define({});
OldMapStashTabLayout.define({});
Orientation.define({});
PVPType.define({});
PantheonPanelLayout.define({
  effect1_stats: [Stat],
  effect2_stats: [Stat],
  effect3_stats: [Stat],
  effect4_stats: [Stat],
});
PantheonSoul.define({
  base_item_type: BaseItemType,
});
PassiveJewelSlot.define({
  passive_skill: PassiveSkill,
});
PassiveSkill.define({
  achievement_item: AchievementItem,
  granted_buff_buff_definition: BuffDefinition,
  ascendancy: Ascendancy,
  stats: [Stat],
  characters: [Character],
  reminder_client_strings: [ClientString],
});
PathOfEndurance.define({
  mods: [Mod],
});
PerLevelValue.define({});
PerandusBoss.define({
  monster_variety: MonsterVariety,
});
PerandusChest.define({
  chest: Chest,
});
PerandusDaemon.define({
  monster_variety: MonsterVariety,
});
PerandusGuard.define({
  monster_packs: [MonsterPack],
});
Pet.define({
  base_item_type: BaseItemType,
});
PreloadGroup.define({});
PreloadPriority.define({});
Projectile.define({});
ProjectileVariation.define({
  projectile: Projectile,
});
Prophecy.define({
  prophecy_chain: ProphecyChain,
  quest_tracker_client_strings: [ClientString],
});
ProphecyChain.define({});
ProphecyType.define({});
Quest.define({});
QuestAchievement.define({
  achievement_item: AchievementItem,
});
QuestFlag.define({});
QuestReward.define({
  quest: Quest,
  character: Character,
  base_item_type: BaseItemType,
});
QuestState.define({
  quest: Quest,
  map_pins1: [MapPin],
  map_pins2: [MapPin],
});
QuestStaticReward.define({
  quest: Quest,
  client_string: ClientString,
  stats: [Stat],
});
QuestVendorReward.define({
  npc: NPC,
  characters: [Character],
  base_item_types: [BaseItemType],
});
Race.define({});
RaceArea.define({
  race: Race,
  world_area: WorldArea,
  mods: [Mod],
});
RaceTime.define({
  race: Race,
});
RandomUniqueMonster.define({});
Rarity.define({});
Realm.define({});
RelativeImportanceConstant.define({});
RogueExile.define({
  monster_variety: MonsterVariety,
});
RunicCircle.define({});
ShieldType.define({
  base_item_type: BaseItemType,
});
ShopCategory.define({
  applied_to_base_item_type: BaseItemType,
});
ShopCountry.define({
  shop_currency: ShopCurrency,
});
ShopCurrency.define({});
ShopItem.define({
  package_shop_item: [ShopItem],
  shop_category: [ShopCategory],
});
ShopItemPrice.define({
  shop_item: ShopItem,
  shop_region: ShopRegion,
});
ShopPackagePlatform.define({});
ShopPaymentPackage.define({
  upgrade_shop_payment_package: ShopPaymentPackage,
});
ShopPaymentPackageItem.define({
  shop_payment_package: ShopPaymentPackage,
  shop_item: ShopItem,
  shop_token: ShopToken,
});
ShopPaymentPackagePrice.define({
  shop_payment_package: ShopPaymentPackage,
  shop_country: ShopCountry,
});
ShopRegion.define({});
ShopToken.define({});
Shrine.define({
  player_shrine_buff: ShrineBuff,
  monster_shrine_buff: ShrineBuff,
  summon_monster_monster_variety: MonsterVariety,
  summon_player_monster_variety: MonsterVariety,
  shrine_sound: ShrineSound,
  achievement_items: [AchievementItem],
});
ShrineBuff.define({
  buff_definition: BuffDefinition,
});
ShrineSound.define({});
SkillGem.define({
  base_item_type: BaseItemType,
  granted_effect: GrantedEffect,
  vaal_variant_base_item_type: BaseItemType,
  gem_tags: [GemTag],
});
SkillTotem.define({});
SkillTotemVariation.define({
  skill_totem: SkillTotem,
  monster_variety: MonsterVariety,
});
SoundEffect.define({});
Stat.define({
  main_hand_alias_stat: Stat,
  off_hand_alias_stat: Stat,
});
StatDescriptionFunction.define({});
StatInterpolationType.define({});
StatSemantic.define({});
StrDexIntMission.define({
  npc_talk: NPCTalk,
  monster_pack: MonsterPack,
  extra_mods: [Mod],
  achievement_items: [AchievementItem],
});
StrDexIntMissionExtraRequirement.define({
  npc_talk: NPCTalk,
});
StrDexIntMissionMap.define({
  world_area: WorldArea,
  map_boss_monster_varieties: [MonsterVariety],
});
StrDexIntMissionMod.define({
  mods: [Mod],
});
StrDexIntMissionUniqueMap.define({
  world_area: WorldArea,
  mods: [Mod],
  map_boss_monster_varieties: [MonsterVariety],
});
StrDexMission.define({
  dummy_monster_variety: MonsterVariety,
  npc_talk: NPCTalk,
  allies_monster_varieties: [MonsterVariety],
  mods: [Mod],
  traps_monster_varieties: [MonsterVariety],
});
StrDexMissionArchetype.define({
  monster_variety: MonsterVariety,
});
StrDexMissionMod.define({
  mods: [Mod],
});
StrDexMissionSpecialMod.define({
  mods: [Mod],
});
StrIntMission.define({
  relic_monster_variety: MonsterVariety,
  npc_talk: NPCTalk,
  relic_mods: [Mod],
  achievement_items: [AchievementItem],
});
StrIntMissionMonsterWave.define({
  monster_pack: MonsterPack,
  unique_monster_varieties: [MonsterVariety],
});
StrIntMissionRelicMod.define({
  mods: [Mod],
});
StrIntMissionRelicPattern.define({
  relic_mods: [Mod],
});
StrMission.define({
  npc_talk: NPCTalk,
  mods: [Mod],
});
StrMissionBoss.define({
  monster_variety: MonsterVariety,
});
StrMissionMapMod.define({
  mod: Mod,
});
StrMissionMapModNumber.define({});
StrMissionSpiritEffect.define({
  summon_monster_varietiess: MonsterVariety,
  ground_effect_monster_varietiess: MonsterVariety,
});
StrMissionSpiritSecondaryEffect.define({
  monster_variety: MonsterVariety,
});
Strongbox.define({
  chest: Chest,
});
SummonedSpecificBarrel.define({
  chest: Chest,
});
SummonedSpecificMonster.define({
  monster_variety: MonsterVariety,
});
SummonedSpecificMonstersOnDeath.define({
  monster_variety: MonsterVariety,
});
SupporterPackSet.define({});
Tag.define({});
Talisman.define({
  base_item_type: BaseItemType,
  mod: Mod,
});
TalismanMonsterMod.define({});
TalismanPack.define({
  monster_variety: MonsterVariety,
  monster_pack: MonsterPack,
  monster_packs: [MonsterPack],
});
TerrainPlugin.define({});
Tip.define({});
Topology.define({});
TormentSpirit.define({
  monster_variety: MonsterVariety,
  summoned_monster_monster_variety: MonsterVariety,
  spirit_mods: [Mod],
  touched_mods: [Mod],
  possessed_mods: [Mod],
  mods0: [Mod],
  mods1: [Mod],
});
TriggerSpawner.define({});
Tutorial.define({});
UniqueChest.define({
  word: Word,
  flavour_text: FlavourText,
  appearance_chest: Chest,
  chest: Chest,
  mods: [Mod],
});
UniqueFragment.define({});
UniqueJewelLimit.define({});
UniqueSet.define({
  word: Word,
});
UniqueSetName.define({});
VoteState.define({});
VoteType.define({});
WarbandsGraph.define({
  world_area: WorldArea,
});
WarbandsMapGraph.define({
  world_area: WorldArea,
});
WarbandsPackMonster.define({
  tier4_monster_varieties: [MonsterVariety],
  tier3_monster_varieties: [MonsterVariety],
  tier2_monster_varieties: [MonsterVariety],
  tier1_monster_varieties: [MonsterVariety],
});
WarbandsPackNumber.define({});
WeaponArmourCommon.define({});
WeaponClass.define({});
WeaponDamageScaling.define({});
WeaponImpactSoundDatum.define({});
WeaponSoundType.define({});
WeaponType.define({
  base_item_type: BaseItemType,
});
Word.define({
  spawn_weight_tags: [Tag],
});
Wordlist.define({});
WorldArea.define({
  parent_town_world_area: WorldArea,
  achievement_item: AchievementItem,
  twinned_full_clear_achievement_item: AchievementItem,
  enter_achievement_item: AchievementItem,
  first_entry_npc_text_audio: NPCTextAudio,
  first_entry_sound_effect: SoundEffect,
  first_entry_npc: NPC,
  environment: Environment,
  connections_world_areas: [WorldArea],
  topologies: [Topology],
  bosses_monster_varieties: [MonsterVariety],
  monsters_monster_varieties: [MonsterVariety],
  spawn_weight_tags: [Tag],
  full_clear_achievement_items: [AchievementItem],
  mods: [Mod],
  vaal_area_world_areas: [WorldArea],
  area_type_tags: [Tag],
  tags: [Tag],
  waypoint_activation_achievement_items: [AchievementItem],
  completion_achievement_items: [AchievementItem],
});
XPPerLevelForMission.define({});
ZanaQuest.define({
  quest: Quest,
});



// WEBPACK FOOTER //
// ./src/schema/generated.js